(function () {
  'use strict';

  var GLOBAL_KEY = 'ArcaverseProductCustomSelectsV1';

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].init === 'function') {
    window[GLOBAL_KEY].init();
    return;
  }

  var ROOT_SELECTOR = '[id^="av-product-hero-"]';
  var SELECT_SELECTOR = [
    'select.av-product-hero__select',
    'select.av-product-option-select',
    'select.av-color-select',
    'select.av-builder-rule-control',
    'select.av-lid-color-select'
  ].join(',');
  var ENHANCED_CLASS = 'av-product-native-select--enhanced';
  var enhancedSelects = new Set();
  var syncTimer = null;

  function selectedOption(select) {
    return select.options[select.selectedIndex] || select.options[0] || null;
  }

  function optionLabel(option) {
    return option ? (option.textContent || option.value || '').trim() : '';
  }

  function closeCustom(custom) {
    if (!custom) return;
    custom.classList.remove('is-open');
    var button = custom.querySelector('.av-product-custom-select__button');
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-av-product-custom-select].is-open').forEach(function (custom) {
      if (custom !== except) closeCustom(custom);
    });
  }

  function getOptionsSignature(select) {
    return Array.prototype.map.call(select.options, function (option) {
      return [option.value, option.textContent, option.disabled ? '1' : '0'].join('::');
    }).join('||');
  }

  function startSharedSyncLoop() {
    if (syncTimer) return;

    syncTimer = window.setInterval(function () {
      enhancedSelects.forEach(function (instance) {
        if (!instance.select.isConnected) {
          if (instance.observer) instance.observer.disconnect();
          enhancedSelects.delete(instance);
          return;
        }

        var optionsSignature = getOptionsSignature(instance.select);
        if (optionsSignature !== instance.lastOptionsSignature) {
          instance.lastOptionsSignature = optionsSignature;
          instance.lastValue = instance.select.value;
          instance.lastDisabled = instance.select.disabled;
          instance.rebuildOptions();
          return;
        }

        if (instance.select.value !== instance.lastValue) {
          instance.lastValue = instance.select.value;
          instance.updateSelectedUi();
        }

        if (instance.select.disabled !== instance.lastDisabled) {
          instance.lastDisabled = instance.select.disabled;
          instance.syncDisabled();
        }
      });

      if (!enhancedSelects.size && syncTimer) {
        window.clearInterval(syncTimer);
        syncTimer = null;
      }
    }, 400);
  }

  function enhanceSelect(select) {
    if (!select || select.dataset.avProductCustomSelectEnhanced === 'true') return;

    var custom = document.createElement('div');
    custom.className = 'av-product-custom-select';
    custom.setAttribute('data-av-product-custom-select', '');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'av-product-custom-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    var value = document.createElement('span');
    value.className = 'av-product-custom-select__value';

    var chevron = document.createElement('span');
    chevron.className = 'av-product-custom-select__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML = '<svg viewBox="0 0 14 9" focusable="false"><path d="M1 1.4l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    button.appendChild(value);
    button.appendChild(chevron);

    var menu = document.createElement('div');
    menu.className = 'av-product-custom-select__menu';
    menu.setAttribute('role', 'listbox');
    menu.tabIndex = -1;

    custom.appendChild(button);
    custom.appendChild(menu);
    select.insertAdjacentElement('afterend', custom);

    select.dataset.avProductCustomSelectEnhanced = 'true';
    select.classList.add(ENHANCED_CLASS);
    select.setAttribute('tabindex', '-1');

    var instance = {
      select: select,
      custom: custom,
      button: button,
      menu: menu,
      observer: null,
      lastValue: select.value,
      lastDisabled: select.disabled,
      lastOptionsSignature: getOptionsSignature(select),
      updateSelectedUi: null,
      rebuildOptions: null,
      syncDisabled: null
    };

    function syncDisabled() {
      button.disabled = select.disabled;
      custom.classList.toggle('is-disabled', select.disabled);
      if (select.disabled) closeCustom(custom);
    }

    function updateSelectedUi() {
      var current = selectedOption(select);
      value.textContent = optionLabel(current);
      Array.prototype.forEach.call(menu.querySelectorAll('.av-product-custom-select__option'), function (optionButton) {
        var isSelected = optionButton.dataset.value === select.value;
        optionButton.classList.toggle('is-selected', isSelected);
        optionButton.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
      syncDisabled();
    }

    function rebuildOptions() {
      menu.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (option) {
        var optionButton = document.createElement('button');
        optionButton.type = 'button';
        optionButton.className = 'av-product-custom-select__option';
        optionButton.setAttribute('role', 'option');
        optionButton.dataset.value = option.value;
        optionButton.textContent = optionLabel(option);
        optionButton.disabled = option.disabled;
        optionButton.addEventListener('click', function () {
          chooseOption(optionButton, true);
        });
        menu.appendChild(optionButton);
      });
      updateSelectedUi();
    }

    function optionButtons() {
      return Array.prototype.slice.call(menu.querySelectorAll('.av-product-custom-select__option:not(:disabled)'));
    }

    function focusOption(delta) {
      var options = optionButtons();
      if (!options.length) return;
      var active = document.activeElement;
      var index = options.indexOf(active);
      if (index < 0) {
        index = Math.max(0, options.findIndex(function (optionButton) {
          return optionButton.dataset.value === select.value;
        }));
      } else {
        index = (index + delta + options.length) % options.length;
      }
      options[index].focus();
    }

    function openMenu() {
      if (button.disabled) return;
      closeAll(custom);
      custom.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }

    function toggleMenu() {
      if (custom.classList.contains('is-open')) {
        closeCustom(custom);
      } else {
        openMenu();
      }
    }

    function chooseOption(optionButton, fromPointer) {
      if (!optionButton || optionButton.disabled) return;
      select.value = optionButton.dataset.value;
      updateSelectedUi();
      select.dispatchEvent(new Event('change', { bubbles: true }));
      closeCustom(custom);
      if (fromPointer) {
        button.blur();
      } else {
        button.focus();
      }
    }

    button.addEventListener('click', toggleMenu);
    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openMenu();
        focusOption(event.key === 'ArrowDown' ? 1 : -1);
      } else if (event.key === 'Escape') {
        closeCustom(custom);
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleMenu();
      }
    });

    menu.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        focusOption(event.key === 'ArrowDown' ? 1 : -1);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closeCustom(custom);
        button.focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        chooseOption(document.activeElement, false);
      } else if (event.key === 'Tab') {
        closeCustom(custom);
      }
    });

    instance.updateSelectedUi = updateSelectedUi;
    instance.rebuildOptions = rebuildOptions;
    instance.syncDisabled = syncDisabled;

    select.addEventListener('change', function () {
      instance.lastValue = select.value;
      updateSelectedUi();
    });

    var observer = new MutationObserver(function () {
      instance.lastValue = select.value;
      instance.lastDisabled = select.disabled;
      instance.lastOptionsSignature = getOptionsSignature(select);
      rebuildOptions();
    });
    observer.observe(select, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
    instance.observer = observer;

    enhancedSelects.add(instance);
    startSharedSyncLoop();
    rebuildOptions();
  }

  function initRoot(root) {
    if (!root) return;
    root.querySelectorAll(SELECT_SELECTOR).forEach(enhanceSelect);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-av-product-custom-select]')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  window[GLOBAL_KEY] = {
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
